import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m10.5 15.75-6.172 3.245 1.179-6.873L.514 7.255l6.9-1.002L10.5 0l3.086 6.253 6.9 1.002-4.993 4.867 1.179 6.873z",
      fill: "#000",
      style: {"opacity":"0.2"},
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }